import * as React from 'react';
import bugsnagClient from './BugsnagClient';
import styled from 'styled-components';

const BugsnagErrorWrapper = bugsnagClient
    .getPlugin('react')
    .createErrorBoundary(React);

const ErrorInfoWrapper = styled.pre`
    max-width: 80vw;
    overflow-x: scroll;
    padding: 1rem 1.5rem;
    border: 1px solid darkred;
    color: mistyrose;
    background-color: maroon;
    border-radius: 0.2rem;
`;

const Link = styled.a`
    color: ${({ theme }) => theme.purple_1};
    text-decoration: underline;
    text-transform: capitalize;
`;

function ErrorInfo({ info }) {
    if (!(info && info.componentStack)) {
        return null;
    }
    return <ErrorInfoWrapper>{info.componentStack}</ErrorInfoWrapper>;
}

function ErrorPage({ error, info }) {
    return (
        <aside css="max-width: 50rem; padding: 1rem 2rem; margin: 1rem auto;">
            <h2 css="text-transform: capitalize;">
                Something went wrong
                <br />
                This page is not trending any more...
            </h2>
            <p
                css={`
                    font-family: ${({ theme }) => theme.style_primary};
                `}
            >
                Our team has been notified of this issue and is working on a
                fix.{' '}
            </p>
            <div>
                <Link href="/">Return to your dashboard</Link>
            </div>
            {process.env.NODE_ENV === 'development' ? (
                <section>
                    <h3 css="text-transform: unset;">
                        {error.name}: {error.message}
                    </h3>
                    <ErrorInfo info={info} />
                </section>
            ) : null}
        </aside>
    );
}

function ErrorBoundary({ children, FallbackComponent = ErrorPage }) {
    return (
        <BugsnagErrorWrapper FallbackComponent={FallbackComponent}>
            {children}
        </BugsnagErrorWrapper>
    );
}

export default ErrorBoundary;
